import { AccountTaxTypeGroup } from '@ndvr/portfolio-api';

export const taxTypeMap = {
    [AccountTaxTypeGroup.TAXABLE]: 'Taxable',
    [AccountTaxTypeGroup.TAX_EXEMPT]: 'Tax Exempt',
    [AccountTaxTypeGroup.TAX_DEFERRED]: 'Tax Deferred',
};
